namespace Matrix.Data.Repositories {
    export interface TestRunRequest extends Serenity.ServiceRequest {
        TestCode?: string;
    }
}
